import  gql  from 'graphql-tag'

export const OFFICE_DIRECTOR = gql`mutation officeDirector($input: OfficeDirectorMutationInput!){
    officeDirector(input: $input){
        errors{
            field
            messages
        }
        officeDirector{
            id
            user{
                id
                name
                surname
                username
                email
                authSystem
                isActive
                group{
                    id
                    name
                }
                officedirector{
                    id
                    office{
                        id
                        name
                        regional{
                            id
                            name
                        }
                    }
                }
            }
        }
    }
}`;